export const styles = {
	BtnHubSpot: {
		color: '#212121',
		backgroundColor: '#8098b2'
	}
};
